import { getParsedPhoneNumberString } from "../modifiers";

export const getFullPhoneNumberString = (
  countryCode: string,
  phoneNumber: string,
): string => `${countryCode}${getParsedPhoneNumberString(phoneNumber)}`;
